import PageFooter from "@components/common/PageFooter";

const GiftPageFooter = () => {
  return (
    <div className="gift-page-footer">
      {/* Gift pages are marketing-facing — offer the marketing locale set
          (VITE_ENABLED_MARKETING_LANGS is the source of truth; don't
          enumerate it here, it drifts — see PR #842) instead of the full
          technique locale set, which also includes ru/ja/ko/zh for the
          techniques library. */}
      <PageFooter
        bgColor="bg-sugar"
        textColor="text-ui-coal"
        useMarketingLangs
      />
    </div>
  );
};

export default GiftPageFooter;
